<script>
    import Button from 'views/components/button/Button.svelte'
    import Modal from 'views/components/modals/Modal.svelte'
    import LearnbeatAppUtil from 'util/LearnbeatAppUtil';

    function openDownloadLink() {
        window.open(
            'https://apps.microsoft.com/detail/9NTKH7CHH9H1',
            '_blank'
        )
    }
</script>

<Modal title={window.i18n.gettext('Your teacher activated the focus mode')}>

    <div class="body-text">{window.i18n.gettext('Focus mode is only available in the app. Open Learnbeat in the app to continue.')}</div>

    <svelte:fragment slot="buttons">
        <Button
            label={window.i18n.gettext('Download app')}
            theme="secondary"
            callback={openDownloadLink}>
        </Button>
        <Button
            label={window.i18n.gettext('Open app')}
            callback={() => LearnbeatAppUtil.onClickOpenInApp(false)}>
        </Button>
    </svelte:fragment>

</Modal>

<style lang="scss">
    .body-text {
        @include large-text;
    }
</style>
